import { LOCAL_STORAGE_KEYS } from "../utils/constants";
import { invokeApi } from "../utils/invokeApi";

export const fetchUserActivitiesService = (module_code, profile_id) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN));

    let requestObj = {
        path: `/my_dq/learning_program/get_user_activities`,
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`
        }
    };

    requestObj['postData'] = {
        module_code,
        profile_id
    };

    return invokeApi(requestObj);
};


export const fetchActivityResponsesService = (module_code, activity_type, segment, slide_index, slide_id, session) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN));

    let requestObj = {
        path: `/my_dq/learning_program/get_activity_responses`,
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`
        }
    };

    requestObj['postData'] = {
        module_code,
        activity_type,
        segment,
        slide_index,
        slide_id,
        session,
    };

    return invokeApi(requestObj);
};
